import { render, staticRenderFns } from "./PatientVisit.vue?vue&type=template&id=a9b02a18"
import script from "./PatientVisit.vue?vue&type=script&lang=js"
export * from "./PatientVisit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports